import React, { useState } from 'react';
import { Breadcrumb, Col, Form, Row, Modal, Button } from 'react-bootstrap';
import SecBTN from '../../UI/SecBTN';
import Input from '../../UI/Input/Input';
import userService from '../../app/services/user.service';
import { toast } from 'react-toastify';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const FacultyPaperRemove = () => {
  const [paperId, setPaperId] = useState('');
  const [facultyId, setFacultyId] = useState('');

  const [showModal, setShowModal] = useState(false);
  const [paperData, setPaperData] = useState(null);

  const GetPaperDetails = () => {
    if (!paperId || !facultyId) {
      toast.warning("Please enter Paper ID and Faculty ID");
      return;
    }
    userService
      .GetPaperDetails({
        paper_id: paperId,
        faculty_id: facultyId,
      })
      .then((res) => {
        console.log(res.data[0][0]);
        
       
        
          setPaperData(res.data[0][0]);
          setShowModal(true);
        
      })
      .catch((err) => {
        toast.error("Something went wrong");
        console.log(err);
      });
  };
  const RemoveFacultyPaper = () => {
    userService
      .RemoveFacultyPaper({
        paper_id: paperId,
        faculty_id: facultyId,
      })
      .then((res) => {
        console.log(res.data);

          setShowModal(false);
          toast.success("Paper Removed Successfully")
        
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong");
      });
  };

  const handleRemove = () => {
    // Call remove API here
    console.log('Remove Paper');
    setShowModal(false);
  };

  return (
    <div className="section">
      <h4>Faculty Paper Remove</h4>

      <Breadcrumb>
        <Breadcrumb.Item active>
          Faculty Paper Remove
        </Breadcrumb.Item>
      </Breadcrumb>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        theme="colored"
      />

      <Row>
        <Col lg={4} md={6} sm={12}>
          <Form.Label>Paper Id:</Form.Label>
          <Input
            type="number"
            value={paperId}
            onChange={(e) => setPaperId(e.target.value)}
            placeholder="Enter Paper Id"
          />
        </Col>

        <Col lg={4} md={6} sm={12}>
          <Form.Label>Faculty Id:</Form.Label>
          <Input
            type="number"
            value={facultyId}
            onChange={(e) => setFacultyId(e.target.value)}
            placeholder="Enter Faculty Id"
          />
        </Col>

        <Col
          lg={4}
          md={6}
          sm={12}
          className="d-flex align-items-end"
        >
          <SecBTN
            className="sec-btn1"
            onClick={GetPaperDetails}
          >
            Search
          </SecBTN>
        </Col>
      </Row>

      {/* Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Paper Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            <strong>Paper Name:</strong>{' '}
            {paperData?.paper_name}
          </p>

          <p>
            <strong>Faculty Name:</strong>{' '}
            {paperData?.faculty_name}
          </p>
        </Modal.Body>

        <Modal.Footer className="justify-content-start">
        <SecBTN
            className="sec-btn1"
            onClick={RemoveFacultyPaper}
          >
            Clear Paper
          </SecBTN>

          <SecBTN
            className="sec-btn1"
            onClick={()=>setShowModal(false)}
          >
            Cancel
          </SecBTN>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default FacultyPaperRemove;